<template>
  <div class="avatar_wrapper" :style="style">
    <img v-if="src" :src="src" :style="style" />
    <img v-else src="@/components/icons/user.svg" :style="style" />
  </div>
</template>

<script>
/**
 * @vue-prop {Number} size — width and height of avatar sizes
 * @vue-prop {Boolean} rounded — rounded (50%) corners of avatar wrapper
 * @vue-prop {String} src — avatar image source
 * @vue-computed {Object} style — computed styles for avatar wrapper div
 */
export default {
  props: {
    size: {
      type: String,
      default: '40px',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: '',
    },
  },
  computed: {
    style() {
      return {
        width: this.size,
        height: this.size,
        borderRadius: this.rounded ? '50%' : 0,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  &_wrapper {
    @include unselectable();

    img {
      object-fit: cover;
    }
  }
}
</style>
